<ion-content *ngIf="browserFormPost" style="visibility: hidden">
  <form
    [formGroup]="form"
    id="externalForm"
    [action]="browserFormPost"
    method="POST"
  >
    <textarea
      formControlName="cXML-urlencoded"
      id="cXML-urlencoded"
      rows="40"
      cols="120"
      name="cXML-urlencoded"
    ></textarea>
  </form>
</ion-content>
